import React, { useEffect, useState, useRef } from 'react';
import partnerPointDetail1 from '../../assets/images/partner/partner_point_detail_1.png';
import partnerPointDetail1Mobile from '../../assets/images/partner/partner_point_detail_1_mobile.png';
import partnerPointDetailCategory1 from '../../assets/images/partner/partner_point_detail_category_1.png';

function PartnerPoint1() {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.05,
        rootMargin: '-50px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="md:h-[800px] w-full flex justify-center bg-[#340065] overflow-hidden">
      <div className="w-full pt-[50px] md:pt-[0px] flex flex-col-reverse md:flex-row items-center justify-between mx-4 md:mx-[60px] bg-[#FDF4FF] rounded-t-[50px] rounded-b-none">
        {/* 왼쪽 이미지 영역 */}
        <div
          className={`w-full pt-[40px] md:pt-[0px] md:w-1/2 flex justify-center md:justify-end items-center md:items-end mb-[5px] md:mb-0 mt-[5px] md:mt-0 transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <div className="relative w-[340px] md:w-[739px] h-[380px] md:h-[800px] flex justify-center md:justify-end items-center md:items-end">
            <img
              src={isMobile ? partnerPointDetail1Mobile : partnerPointDetail1}
              alt="폰피쉬 앱 화면"
              className="w-full h-full object-contain drop-shadow-lg"
            />
          </div>
        </div>

        {/* 오른쪽 텍스트 영역 */}
        <div
          className={`w-full md:w-1/2 flex flex-col justify-center items-center md:items-start px-4 md:px-[120px] space-y-[16px] md:space-y-[60px] transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <img
            src={partnerPointDetailCategory1}
            alt="고객 유입 & 매출 UP"
            className="w-[232px] h-[63px] md:w-[296px] md:h-[80px] object-contain"/>

          <h2 className="font-pretendard font-bold text-[24px] md:text-[40px] leading-[140%] text-black text-center md:text-left">
            아이돌 마케팅 기반 유입,<br />오프라인 방문과 매출 상승
          </h2>

          <p className="font-pretendard font-normal text-[16px] md:text-[22px] leading-[180%] text-black text-center md:text-left">
            ⭐ 인플루언서와 아이돌 팬덤 기반 유입 확대<br />
            🎯 온라인 체험 후 매장 방문으로 자연스러운 연결<br />
            📈 오프라인 방문과 함께 실매출 성장
          </p>
        </div>
      </div>
    </section>
  );
}

export default PartnerPoint1; 